import requests from "./httpService";

const CashbookServices = {
  createPassbook: async (body) => {
    return requests.post("/site-cash-passbooks", body);
  },

  getPassbooks: async () => {
    return requests.get("/site-cash-passbooks");
  },

  getMyPassbookByStore: async (storeId) => {
    return requests.get(
      `/site-cash-passbooks/my-passbook?storeId=${encodeURIComponent(storeId)}`
    );
  },

  updatePassbookStatus: async (id, status) => {
    return requests.patch(
      `/site-cash-passbooks/${id}/status`,
      { status }
    );
  }
};

export default CashbookServices;